import React, {Fragment, useContext} from 'react';
import ListItemButton from "@mui/material/ListItemButton";
import {v4} from "uuid";
import ListItem from "@mui/material/ListItem";
import Box from "@mui/material/Box";
import {KeyboardArrowDown, KeyboardArrowUp} from "@mui/icons-material";
import {Collapse, List} from "@mui/material";
import {GlobalContext} from "../state/GlobalContextProvider";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

interface SideMenuListProps {
    selected: any[];
    setSelected: any;
    setOpen: any;
}

const SideMenuList = ({selected, setSelected, setOpen}: SideMenuListProps) => {
    const {t} = useTranslation();
    const {globalData} = useContext(GlobalContext);
    let navigate = useNavigate();

    const handleSelect = (item: any, event:React.MouseEvent) => {
        let reload = false;
        let selectedMenuItems = [...selected];
        selectedMenuItems?.includes(item) ? (item.menuSubItems?.length !== 0 ? selectedMenuItems = selectedMenuItems.filter(i => i !== item) : reload = true) : selectedMenuItems = [...selectedMenuItems.filter(i => i.deep < item.deep), item];
        setSelected(selectedMenuItems);
        if (item.menuSubItems?.length === 0 && selectedMenuItems?.includes(item)) {
            setOpen(false);
            if (event.ctrlKey || event.metaKey) {
                window.open(window.location.origin + selectedMenuItems.sort((a, b) => a.deep - b.deep).map(a => a.path).join(''));
            } else {
                navigate(selectedMenuItems.sort((a, b) => a.deep - b.deep).map(a => a.path).join(''));
                if (reload) {
                    //window.location.reload();
                }
            }
        }
    }

    const renderMenuItems = (menuItem: any, menuSubItems: any[]) => {
        const isOpen = selected?.includes(menuItem);
        return (
            <Fragment key={v4()}>
                <ListItem disablePadding
                          onClick={(event) => handleSelect(menuItem, event)}>
                    <ListItemButton
                        className={isOpen ? 'menuSelected' : 'default'}>
                        <Box sx={{flexGrow: 1}}>{t('menu.'.concat(menuItem.code).concat('.main'))} </Box> {!isOpen ?
                        <KeyboardArrowDown/> :
                        <KeyboardArrowUp/>}
                    </ListItemButton>
                </ListItem>
                <Collapse in={isOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding
                          className={'subItem default'}>
                        {menuSubItems.map((subItem: any) => {
                            if (subItem.menuSubItems.length > 0) {
                                return renderMenuItems(subItem, subItem.menuSubItems);
                            } else {
                                return (
                                    <ListItemButton className={selected?.includes(subItem) ? 'menuSelected' : 'default'}
                                                    key={v4()} onClick={(event) => handleSelect(subItem, event)}>
                                        {t('menu.'.concat(menuItem.code).concat('.').concat(subItem.code))}
                                    </ListItemButton>
                                )
                            }
                        })}
                    </List>
                </Collapse>
            </Fragment>
        )
    }

    return (
        <List sx={{paddingBottom: '80px'}}>
            {globalData.user && globalData.user.menuItems?.map((menuItem: any) => {
                if (menuItem.menuSubItems.length > 0) {
                    return renderMenuItems(menuItem, menuItem.menuSubItems);
                } else {
                    return (
                        <ListItemButton className={(selected.includes(menuItem)) ? 'menuSelected' : 'default'}
                                        key={v4()} onClick={(event) => handleSelect(menuItem, event)}>
                            {t('menu.'.concat(menuItem.code).concat('.main'))}
                        </ListItemButton>
                    )
                }
            })}
        </List>
    );
};

export default SideMenuList;